import type { CargaEstadoProps } from "./types-carga-estado";
import { CargaEstadoView } from "./view-carga-estado";

/** Carregando, erro, acesso negado ou vazio da Carga de Trabalho; com dados, não desenha nada. */
export function CargaEstado(props: CargaEstadoProps) {
  return <CargaEstadoView {...props} />;
}

export type * from "./types-carga-estado";
